export function isClientError(error: unknown): boolean {
  if (error && typeof error === 'object') {
    const status
      = (error as { response?: { status?: unknown } }).response?.status
        ?? (error as { status?: unknown }).status
    if (typeof status === 'number') {
      return status >= 400 && status < 500
    }
  }
  return false
}

export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  return !isClientError(error) && failureCount < 3
}
